import { gunzipSync } from "zlib";

export const unzipIfArchived = (value: any) => {
	return typeof value === "string" ? JSON.parse(value) : JSON.parse(gunzipSync(value).toString());
};
